import React from "react";

import {
    LiveEventsScheduleProps,
    LiveEventsScheduleState
} from "./models";

import {
    Box,
    Grid,
    Tabs,
    Typography
} from "@mui/material";

import { tabsClasses } from "@mui/material/Tabs";

import { ContentPreviewElement } from "components/content-preview-element/content-preview-element";

import {
    StyledTab,
    TabPanel
} from "commons/commons";

import { TimelineService } from "services/timeline-service";
import { Trans } from "@lingui/macro";

export class LiveEventsSchedule extends React.Component<LiveEventsScheduleProps, LiveEventsScheduleState> {

    constructor(props: Readonly<LiveEventsScheduleProps> | LiveEventsScheduleProps) {
        super(props);

        this.state = {
            success: false,
            response: {
                list: []
            },
            liveEvent: [],
            loaded: true,
            value: 0,
        };
    }

    getTimelineContentCallback = (data: any) => {

        this.setState(() => ({ success: true, response: data }));
    }

    getTimelineContentErrorCallback = (err: any) => {
        console.log(err);
    };

    public componentDidMount() {
        TimelineService.getTimelineContent(this.getTimelineContentCallback, this.getTimelineContentErrorCallback)
    }

    private handleChange = (event: React.SyntheticEvent, newValue: number): void => {
        this.setState(() => ({
            value: newValue
        }));
    };

    private a11yProps(index: number) {
        return {
            id: `simple-tab-${index}`,
            "aria-controls": `simple-tabpanel-${index}`,
        };
    }

    render() {
        return (
            <>
                {this.state.response.list.length !== 0 && <>
                    <Box className={"h-title"} textAlign={"center"} sx={{ mt: 2 }}>
                        <Typography variant={"h1"}
                            sx={{
                                color: "#FFFFFF",
                                fontWeight: "bold",
                                textTransform: "uppercase",
                            }}>
                            <Trans id="h-next-event-title">
                                Prossimi eventi
                            </Trans>
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            flexGrow: 1,
                            bgcolor: "transparent",
                            paddingTop: "5px",
                        }}>
                        <Tabs
                            value={this.state.value}
                            onChange={this.handleChange}
                            variant="scrollable"
                            scrollButtons
                            aria-label="visible arrows tabs example"
                            sx={{
                                [`& .${tabsClasses.scrollButtons}`]: {
                                    backgroundColor: "#A8ADB2",
                                    "&.Mui-disabled": { opacity: 0.7 },
                                    opacity: 0.9,
                                },
                                ".MuiTabs-indicator": {
                                    height: "4px",
                                    transition: "none",
                                },
                            }}
                        >
                            {this.state.response.list.sort((a, b) => a.date.localeCompare(b.date)).map((item, index) => (
                                <StyledTab
                                    key={index}
                                    label={
                                        <Box>
                                            <Typography variant={"h3"}>{new Date(+item.date).getDate()}</Typography>
                                            <Typography
                                                variant={"body2"}>{new Date(new Date(+item.date).toString()).toLocaleString('en-us', { weekday: 'short' })}</Typography>
                                        </Box>
                                    } {...this.a11yProps(index)} />
                            ))}
                        </Tabs>

                        {this.state.response.list.sort((a, b) => a.date.localeCompare(b.date)).map((item, index) => (
                            <TabPanel
                                value={this.state.value}
                                index={index}
                                key={index}>
                                <Grid container direction={"row"} rowSpacing={3} columnSpacing={4.3}>
                                    {item.contents.map(
                                        (item, index) => (
                                            <Grid item xs={"auto"}><ContentPreviewElement content={item}
                                                key={index} /></Grid>
                                        ))}
                                </Grid>
                            </TabPanel>
                        ))}
                    </Box></>
                }
            </>);
    }
}
